import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {getLayerByName, removeLayer} from "@/helpers/ol/ol-layer-helper";
import {Fill, RegularShape, Stroke, Style} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {hexToRgba} from "@/helpers/color-helper";

const layerName = 'mapClickMarker'

export function removeMapClickMarker() {
    removeLayer(layerName, false)
}

export function setMapClickMarker(coordinate) {

    removeMapClickMarker()

    const source = new VectorSource({wrapX: false});

    source.addFeature(new Feature({
        geometry: new Point(coordinate)
    }));

    window.map.addLayer( new VectorLayer({
        altitudeMode: 'clampToGround',
        name: layerName,
        zIndex: 1000,
        source: source,
        style: new Style({
            image: new RegularShape({
                stroke: new Stroke({color: '#FFD950', width: 5}),
                points: 4,
                radius: 12,
                radius2: 0,
                angle: 0,
            }),
        })
    }))
}

export function getMapClickMarker() {
    return getLayerByName(layerName, false)
}
